import { render, staticRenderFns } from "./BuyTokens.vue?vue&type=template&id=6968fc29&scoped=true&"
import script from "./BuyTokens.vue?vue&type=script&lang=js&"
export * from "./BuyTokens.vue?vue&type=script&lang=js&"
import style0 from "./BuyTokens.vue?vue&type=style&index=0&id=6968fc29&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6968fc29",
  null
  
)

export default component.exports